/* tslint:disable */
export const
  localNl = {
    'LANG_DE': 'Duits',
    'LANG_EN': 'Engels',
    'LANG_ES': 'Spaans',
    'LANG_FR': 'Frans',
    'LANG_IT': 'Italiaans',
    'LANG_NL': 'Nederlands',
    'IMPERSONATE_USER': 'Verpersoonlijke gebruiker',
    'LEAVE_IMPERSONATION': 'Verlaat imitatie',
    'MY_PROFILE': 'Mijn profiel',
    'LOGOUT': 'Afmelden',
    'RUN_AS': 'als',
    'CLOSE': null,
    'IMPERSONATE_DIALOG': null,
    'IMPERSONATE_DIALOG_TITLE': null,
    'IMPERSONATE_DIALOG_EXPLAIN_P1': null,
    'IMPERSONATE_DIALOG_EXPLAIN_P2': null,
    'SHOW_X_ELEMENTS_START': null,
    'SHOW_X_ELEMENTS_END': null,
    'SEARCH': null,
    'NAME': null,
    'EMAIL': null,
    'ROLES_GROUP': null,
    'IMPERSONATE': null,
    'CANCEL': null,
    'PAGINATION_INFO': null,
    'FILTERED_PAGINATION_INFO': null,
    'CLIENT_SELECTOR_PLACEHOLDER': null,
    'DASHBOARD': null,
    'USERS': null,
    'FILTERED': null,
    'NOT_FILTERED': null,
    'MY_PROFILE_TITLE': null,
    'MY_PROFILE_PERSONAL_INFO': null,
    'MY_PROFILE_CHANGE_AVATAR': null,
    'MY_PROFILE_CHANGE_PASSWORD': null,
    'MY_PROFILE_IDENTITIES': null,
    'MY_PROFILE_USER_NAME': null,
    'MY_PROFILE_USER_NAME_PLACEHOLDER': null,
    'MY_PROFILE_USER_NAME_REQUIRED': null,
    'MY_PROFILE_USER_EMAIL': null,
    'MY_PROFILE_USER_EMAIL_PLACEHOLDER': null,
    'MY_PROFILE_USER_EMAIL_REQUIRED': null,
    'MY_PROFILE_USER_EMAIL_INVALID': null,
    'MY_PROFILE_USER_CULTURE': null,
    'MY_PROFILE_USER_CULTURE_REQUIRED': null,
    'MY_PROFILE_USER_GENDER': null,
    'MY_PROFILE_USER_TIMEZONE': null,
    'MY_PROFILE_USER_TIMEZONE_REQUIRED': null,
    'MY_PROFILE_USER_PHONE': null,
    'MY_PROFILE_USER_PHONE_PLACEHOLDER': null,
    'MY_PROFILE_USER_FAX': null,
    'MY_PROFILE_USER_FAX_PLACEHOLDER': null,
    'MY_PROFILE_USER_MOBILE': null,
    'MY_PROFILE_USER_MOBILE_PLACEHOLDER': null,
    'MY_PROFILE_USER_SKYPE': null,
    'MY_PROFILE_USER_SKYPE_PLACEHOLDER': null,
    'MY_PROFILE_USER_DEPARTMENT': null,
    'MY_PROFILE_USER_DEPARTMENT_PLACEHOLDER': null,
    'MY_PROFILE_UNSAVED_CHANGES_START': null,
    'MY_PROFILE_UNSAVED_CHANGES_END': null,
    'GENDER_UNDEFINED': null,
    'GENDER_WOMAN': null,
    'GENDER_MAN': null,
    'SAVE_CHANGES': null,
    'SAVING_CHANGES': null,
    'EXTERNAL_ID_LINK': null,
    'EXTERNAL_ID_UNLINK': null,
    'EXTERNAL_ID_GOOGLE': null,
    'EXTERNAL_ID_MSLIVE': null,
    'CHANGE_PASSWORD_STRENGTH': null,
    'PASSWORD_STRENGTH_VERY_WEAK': null,
    'PASSWORD_STRENGTH_VERY_WEAK_DESC': null,
    'PASSWORD_STRENGTH_WEAK': null,
    'PASSWORD_STRENGTH_WEAK_DESC': null,
    'PASSWORD_STRENGTH_REASONABLE': null,
    'PASSWORD_STRENGTH_REASONABLE_DESC': null,
    'PASSWORD_STRENGTH_STRONG': null,
    'PASSWORD_STRENGTH_STRONG_DESC': null,
    'PASSWORD_STRENGTH_VERY_STRONG': null,
    'PASSWORD_STRENGTH_VERY_STRONG_DESC': null,
    'CHANGE_PASSWORD_CURRENT': null,
    'CHANGE_PASSWORD_CURRENT_REQUIRED': null,
    'CHANGE_PASSWORD_NEW': null,
    'CHANGE_PASSWORD_NEW_REQUIRED': null,
    'CHANGE_PASSWORD_NEW_MINLENGTH': null,
    'CHANGE_PASSWORD_NEW_MUST_BE_DIFFERENT': null,
    'CHANGE_PASSWORD_VALIDATION_ERROR_ME': null,
    'CHANGE_PASSWORD_CONFIRM': null,
    'CHANGE_PASSWORD_CONFIRM_MISMATCH': null,
    'CHANGE_PASSWORD_SAVE': null,
    'CHANGE_PASSWORD_SAVING': null,
    'CHANGE_AVATAR_YOURS': null,
    'CHANGE_AVATAR_SELECT': null,
    'CHANGE_AVATAR_CHANGE': null,
    'CHANGE_AVATAR_REMOVE': null,
    'CHANGE_AVATAR_SAVE': null,
    'CHANGE_AVATAR_SAVING': null,
    'ASSIGN_GROUP_DIALOG': null,
    'ASSIGN_GROUP_DIALOG_TITLE': null,
    'ASSIGN_GROUP_DIALOG_SINGLE': null,
    'ASSIGN_GROUP_DIALOG_MULTI': null,
    'ASSIGN_GROUP_DIALOG_GROUP': null,
    'ASSIGN_GROUP_DIALOG_NOSELECTION': null,
    'ASSIGN_GROUP_DIALOG_ACCEPT': null,
    'AUTH0_INFO_TITLE': null,
    'AUTH0_INFO_HISTORY': null,
    'AUTH0_INFO_MAP': null,
    'AUTH0_LOGS_DURATION': null,
    'AUTH0_LOGS_EVENT': null,
    'AUTH0_LOGS_WHEN': null,
    'AUTH0_LOGS_APP': null,
    'AUTH0_LOGS_IDP': null,
    'AUTH0_LOGS_IP': null,
    'AUTH0_LOGS_FROM': null,
    'AUTH0_MAP_SUCCESS_LOGIN': null,
    'CONFIRM_DELETE_USERS_DIALOG': null,
    'CONFIRM_DELETE_USERS_DIALOG_TITLE': null,
    'CONFIRM_DELETE_USERS_DIALOG_SINGLE': null,
    'CONFIRM_DELETE_USERS_DIALOG_MULTI': null,
    'CONFIRM_DELETE_USERS_DIALOG_ACCEPT': null,
    'CREATE_USER_DIALOG': null,
    'CREATE_USER_DIALOG_TITLE': null,
    'CREATE_USER_DIALOG_ACCEPT': null,
    'CREATE_USER_DIALOG_NAME': null,
    'CREATE_USER_DIALOG_NAME_PLACEHOLDER': null,
    'CREATE_USER_DIALOG_NAME_REQUIRED': null,
    'CREATE_USER_DIALOG_EMAIL': null,
    'CREATE_USER_DIALOG_EMAIL_PLACEHOLDER': null,
    'CREATE_USER_DIALOG_EMAIL_REQUIRED': null,
    'CREATE_USER_DIALOG_EMAIL_INVALID': null,
    'CREATE_USER_DIALOG_ROLES_GROUP': null,
    'CREATE_USER_DIALOG_ROLES_GROUP_NONE': null,
    'CREATE_USER_DIALOG_ROLES_GROUP_REQUIRED': null,
    'CREATE_USER_DIALOG_OFFICE': null,
    'CREATE_USER_DUPLICATE': null,
    'OFFICE_NONE': null,
    'OFFICE_BE': null,
    'OFFICE_FR': null,
    'OFFICE_ES': null,
    'OFFICE_DE': null,
    'OFFICE_CN': null,
    'EDIT_USER_NAME': null,
    'EDIT_USER_NAME_PLACEHOLDER': null,
    'EDIT_USER_NAME_REQUIRED': null,
    'EDIT_USER_EMAIL': null,
    'EDIT_USER_EMAIL_PLACEHOLDER': null,
    'EDIT_USER_EMAIL_REQUIRED': null,
    'EDIT_USER_EMAIL_INVALID': null,
    'EDIT_USER_ROLES_GROUP': null,
    'EDIT_USER_ROLES_GROUP_NONE': null,
    'EDIT_USER_ROLES_GROUP_REQUIRED': null,
    'EDIT_USER_OFFICE': null,
    'EDIT_USER_CULTURE': null,
    'EDIT_USER_CULTURE_REQUIRED': null,
    'EDIT_USER_GENDER': null,
    'EDIT_USER_TIMEZONE': null,
    'EDIT_USER_TIMEZONE_REQUIRED': null,
    'EDIT_USER_PHONE': null,
    'EDIT_USER_PHONE_PLACEHOLDER': null,
    'EDIT_USER_FAX': null,
    'EDIT_USER_FAX_PLACEHOLDER': null,
    'EDIT_USER_MOBILE': null,
    'EDIT_USER_MOBILE_PLACEHOLDER': null,
    'EDIT_USER_SKYPE': null,
    'EDIT_USER_SKYPE_PLACEHOLDER': null,
    'EDIT_USER_DEPARTMENT': null,
    'EDIT_USER_DEPARTMENT_PLACEHOLDER': null,
    'IMPORT_USERS_DIALOG': null,
    'IMPORT_USERS_DIALOG_TITLE': null,
    'IMPORT_USERS_DIALOG_CLIENT': null,
    'IMPORT_USERS_DIALOG_CLIENT_NONE': null,
    'IMPORT_USERS_DIALOG_USER': null,
    'IMPORT_USERS_DIALOG_ROLES_GROUP': null,
    'IMPORT_USERS_DIALOG_ROLES_GROUP_NONE': null,
    'IMPORT_USERS_DIALOG_ACCEPT': null,
    'USERS_LIST_TITLE': null,
    'USERS_LIST_CREATE': null,
    'USERS_LIST_IMPORT': null,
    'USERS_LIST_FILTER': null,
    'EXPANDER_TITLE': null,
    'USERS_LIST_FILTER_NAME': null,
    'USERS_LIST_FILTER_EMAIL': null,
    'USERS_LIST_FILTER_ACTIVE': null,
    'USERS_LIST_FILTER_ACTIVE_ALL': null,
    'YES': null,
    'NO': null,
    'USERS_LIST_FILTER_ROLES_GROUP': null,
    'USERS_LIST_FILTER_ROLES_GROUP_ALL': null,
    'USERS_LIST_FILTER_SEARCH': null,
    'USERS_LIST_FILTER_RESET': null,
    'USERS_LIST_SELECT_PAGE': null,
    'USERS_LIST_UNSELECT_PAGE': null,
    'USERS_LIST_ACTIONS': null,
    'USERS_LIST_TOGGLE_STATUS': null,
    'USERS_LIST_ASSIGN_ROLES_GROUP': null,
    'USERS_LIST_LINK_AUDIO_PLAYERS': null,
    'USERS_LIST_UNLINK_AUDIO_PLAYERS': null,
    'USERS_LIST_LINK_VIDEO_PLAYERS': null,
    'USERS_LIST_UNLINK_VIDEO_PLAYERS': null,
    'USERS_LIST_DELETE': null,
    'USERS_LIST_COLUMN_AVATAR': null,
    'USERS_LIST_COLUMN_NAME': null,
    'USERS_LIST_COLUMN_EMAIL': null,
    'USERS_LIST_COLUMN_ROLES_GROUP': null,
    'USERS_LIST_COLUMN_NUMBER_AUDIO': null,
    'USERS_LIST_COLUMN_NUMBER_VIDEO': null,
    'USERS_LIST_COLUMN_STATUS': null,
    'USER_NOT_FOUND': null,
    'USER_SIDEBAR_BLOCK': null,
    'USER_SIDEBAR_UNBLOCK': null,
    'USER_SIDEBAR_DELETE': null,
    'USER_SIDEBAR_RESET_PASSWORD': null,
    'USER_SIDEBAR_USER_INFO': null,
    'USER_SIDEBAR_SUBSCRIPTION_INFO': null,
    'USER_SIDEBAR_CONNECTION_INFO': null,
    'USER_SUBSCRIPTIONS_ASSIGN_ALL': null,
    'USER_SUBSCRIPTIONS_IMPORT': null,
    'USER_SUBSCRIPTIONS_ASSIGNED': null,
    'USER_SUBSCRIPTIONS_ASSIGNED_TEXT': null,
    'USER_SUBSCRIPTIONS_ASSIGNED_FILTER': null,
    'USER_SUBSCRIPTIONS_ASSIGNED_EMPTY': null,
    'USER_SUBSCRIPTIONS_ASSIGNED_TOGGLE': null,
    'USER_SUBSCRIPTIONS_UNASSIGNED': null,
    'USER_SUBSCRIPTIONS_UNASSIGNED_TEXT': null,
    'USER_SUBSCRIPTIONS_UNASSIGNED_FILTER': null,
    'USER_SUBSCRIPTIONS_UNASSIGNED_EMPTY': null,
    'USER_SUBSCRIPTIONS_UNASSIGNED_TOGGLE': null,
    'USER_SUBSCRIPTIONS_IMPORT_DIALOG': null,
    'USER_SUBSCRIPTIONS_IMPORT_DIALOG_TITLE': null,
    'USER_SUBSCRIPTIONS_IMPORT_DIALOG_USER': null,
    'USER_SUBSCRIPTIONS_IMPORT_DIALOG_USER_NONE': null,
    'USER_SUBSCRIPTIONS_IMPORT_DIALOG_ACCEPT': null,
    'USERS_LINK_SUBSCRIPTIONS_DIALOG': null,
    'USERS_UNLINK_SUBSCRIPTIONS_DIALOG': null,
    'USERS_LINK_SUBSCRIPTIONS_DIALOG_TITLE': null,
    'USERS_UNLINK_SUBSCRIPTIONS_DIALOG_TITLE': null,
    'USERS_LINK_SUBSCRIPTIONS_DIALOG_SINGLE': null,
    'USERS_LINK_SUBSCRIPTIONS_DIALOG_MULTI': null,
    'USERS_UNLINK_SUBSCRIPTIONS_DIALOG_SINGLE': null,
    'USERS_UNLINK_SUBSCRIPTIONS_DIALOG_MULTI': null,
    'USERS_UN_LINK_SUBSCRIPTIONS_USERS': null,
    'USERS_UN_LINK_SUBSCRIPTIONS_PLAYERS': null,
    'USERS_UN_LINK_SUBSCRIPTIONS_SELECT_ALL': null,
    'USERS_UN_LINK_SUBSCRIPTIONS_SELECT_NONE': null,
    'USERS_UN_LINK_SUBSCRIPTIONS_LINK': null,
    'USERS_UN_LINK_SUBSCRIPTIONS_UNLINK': null,
    'USER_INFO_TITLE': null,
    'USER_INFO_PERSONAL_INFO': null,
    'USER_INFO_AVATAR': null,
    'USER_INFO_AUDIO_PLAYERS': null,
    'USER_INFO_VIDEO_PLAYERS': null,
    'USER_INFO_UNSAVED_CHANGES_START': null,
    'USER_INFO_UNSAVED_CHANGES_END': null,
    'TOAST_ERROR_TITLE': null,
    'TOAST_SUCCESS_TITLE': null,
    'TOAST_INFO_TITLE': null,
    'TOAST_WARNING_TITLE': null,
    'TOAST_ACCESS_DENIED_TITLE': null,
    'GROUP_ROLES_LOAD_ERROR': null,
    'CULTURES_LOAD_ERROR': null,
    'MY_CLIENTS_LOAD_ERROR': null,
    'SUBSCRIPTIONS_LIST_LOAD_AUDIO_ERROR': null,
    'SUBSCRIPTIONS_LIST_LOAD_VIDEO_ERROR': null,
    'TIMEZONES_LOAD_ERROR': null,
    'USER_LOAD_ERROR_ME': null,
    'USER_LOAD_ERROR': null,
    'USER_SAVE_SUCCESS_ME': null,
    'USER_SAVE_SUCCESS': null,
    'USER_SAVE_ERROR_ME': null,
    'USER_SAVE_VALIDATION_ERROR_ME': null,
    'USER_SAVE_ERROR': null,
    'USER_SAVE_VALIDATION_ERROR': null,
    'USER_CHANGE_AVATAR_SUCCESS_ME': null,
    'USER_CHANGE_AVATAR_SUCCESS': null,
    'USER_CHANGE_AVATAR_ERROR_ME': null,
    'USER_CHANGE_AVATAR_ERROR': null,
    'USER_CHANGE_PASSWORD_SUCCESS': null,
    'USER_CHANGE_PASSWORD_ERROR': null,
    'USER_RESET_PASSWORD_SUCCESS': null,
    'USER_RESET_PASSWORD_ERROR': null,
    'USER_TOGGLE_ACTIVE_SUCCESS': null,
    'USER_TOGGLE_ACTIVE_ERROR': null,
    'USER_REMOVE_SUCCESS': null,
    'USER_REMOVE_ERROR': null,
    'USER_REMOVE_SELF_ERROR': null,
    'USER_LOAD_AUDIO_SUBSCRIPTIONS_ERROR': null,
    'USER_LOAD_VIDEO_SUBSCRIPTIONS_ERROR': null,
    'USER_UPDATE_AUDIO_SUBSCRIPTIONS_SUCCESS': null,
    'USER_UPDATE_AUDIO_SUBSCRIPTIONS_ERROR': null,
    'USER_UPDATE_VIDEO_SUBSCRIPTIONS_SUCCESS': null,
    'USER_UPDATE_VIDEO_SUBSCRIPTIONS_ERROR': null,
    'USER_IMPORT_AUDIO_SUBSCRIPTIONS_SUCCESS': null,
    'USER_IMPORT_AUDIO_SUBSCRIPTIONS_ERROR': null,
    'USER_IMPORT_VIDEO_SUBSCRIPTIONS_SUCCESS': null,
    'USER_IMPORT_VIDEO_SUBSCRIPTIONS_ERROR': null,
    'USER_CONTEXT_IMPERSONATE_ACCESS_DENIED': null,
    'USER_CONTEXT_IMPERSONATE_SUCCESS': null,
    'USER_CONTEXT_IMPERSONATE_ERROR': null,
    'USER_CONTEXT_GET_ROLES_ERROR': null,
    'USER_CONTEXT_GET_IMPERSONABLE_ERROR': null,
    'USERS_LOAD_ERROR': null,
    'USERS_LOAD_BAD_REQUEST_ERROR': null,
    'USERS_DELETE_ERROR': null,
    'USERS_DELETE_SELF_ERROR': null,
    'USERS_DELETE_SUCCESS': null,
    'USERS_REFRESH_ERROR': null,
    'USERS_IMPORT_ERROR': null,
    'USERS_IMPORT_BAD_REQUEST_ERROR': null,
    'USERS_IMPORT_SUCCESS': null,
    'USERS_CREATE_SUCCESS': null,
    'USERS_CREATE_ERROR': null,
    'USERS_CREATE_BAD_REQUEST_ERROR': null,
    'USERS_PATCH_SUCCESS': null,
    'USERS_PATCH_ERROR': null,
    'USERS_UN_LINK_SUBSCRIPTIONS_SUCCESS': null,
    'USERS_UN_LINK_SUBSCRIPTIONS_ERROR': null,
    'AUTH_UNLINK_SUCCESS': null,
    'AUTH_UNLINK_ERROR': null,
    'AUTH_GET_USER_INFO_ERROR': null,
    'AUTH_UPDATE_PROFILE_ERROR': null,
    'AUTH_LOGS_LOAD_ERROR': null,
    'AUTH_LINK_ERROR': null,
    'AUTH_LINK_ERROR_DETAILS': null,
    'ERROR_PAGE_NOT_FOUND': null,
    'ERROR_PAGE_NOT_FOUND_TITLE': null,
    'ERROR_PAGE_NOT_FOUND_PARA': null,
    'ERROR_PAGE_RETURN_HOME': null,
    'ERROR_PAGE_ACCESS_DENIED': null,
    'ERROR_PAGE_ACCESS_DENIED_TITLE': null,
    'ERROR_PAGE_ACCESS_DENIED_PARA': null,
    'AUTH_LOGIN_GENERIC_ERROR': null,
    'AUTH_LOGIN_WRONG_CREDENTIALS': null,
    'AUTH_LOGIN_BLOCKED': null,
    'AUTH_LOGIN_LEAKED': null,
    'AUTH_LOGIN_SOCIAL_FIRST': null,
    'AUTH_LOGIN_ACCESS_DENIED': null,
    'AUTH_LOGIN_INVALID_TOKEN': null,
    'AUTH_LOGIN_AUTO_TITLE': null,
    'AUTH_LOST_PASSWORD_TITLE': null,
    'AUTH_LOST_PASSWORD_PARA': null,
    'AUTH_LOST_PASSWORD_ERROR': null,
    'AUTH_LOST_PASSWORD_SUCCESS': null,
    'AUTH_GOTO_LOGIN_PAGE': null,
    'AUTH_LOST_PASSWORD_EMAIL': null,
    'AUTH_LOST_PASSWORD_EMAIL_REQUIRED': null,
    'AUTH_LOST_PASSWORD_EMAIL_INVALID': null,
    'AUTH_LOST_PASSWORD_BACK': null,
    'AUTH_LOST_PASSWORD_SUBMIT': null,
    'AUTH_LOST_PASSWORD_SUBMITTING': null,
    'AUTH_RESET_PASSWORD_TITLE': null,
    'AUTH_RESET_PASSWORD_PARA': null,
    'AUTH_RESET_PASSWORD_ERROR': null,
    'AUTH_RESET_PASSWORD_SUCCESS': null,
    'AUTH_RESET_PASSWORD_NEW': null,
    'AUTH_RESET_PASSWORD_NEW_REQUIRED': null,
    'AUTH_RESET_PASSWORD_NEW_MINLENGTH': null,
    'AUTH_RESET_PASSWORD_CONFIRM': null,
    'AUTH_RESET_PASSWORD_CONFIRM_MISMATCH': null,
    'AUTH_RESET_PASSWORD_SUBMIT': null,
    'AUTH_RESET_PASSWORD_SUBMITTING': null,
    'PLAYERS': null,
    'PAGE_SIZE_ALL': null,
    'ALL_SUBSCRIPTIONS': null,
    'PLAYERS_LIST_TITLE': null,
    'AUTH_RENEW_PASSWORD_TITLE': 'Your link as expired, please renew the request.',
    'ALERT_PLAYERS_LIST_TITLE': null,
    'PLAYERS_EXPORT_TO_EXCEL': null,
    'ALERT_PLAYERS_TEST_MESSAGE_SEND': null,
    'PLAYERS_DECONNECTED_CREATE': 'Create',
    'PLAYERS_EXPORT_TO_EXCEL_BY_EMAIL': null,
    'PLAYER_TYPE': null,
    'PLAYER_SITE': null,
    'PLAYER_ID': null,
    'PLAYER_STATUS': null,
    'PLAYER_DEFAULT': null,
    'PLAYER_PRODUCT': null,
    'PLAYER_COUNTRY': null,
    'PLAYER_LAST_CONNECTION': null,
    'PLAYER_EXTERNAL_ID': null,
    'PLAYER_ONLINE': null,
    'PLAYER_OFFLINE': null,
    'PLAYER_UPDATE_FAILED': null,
    'PLAYER_UPDATE_INCOMPLETE': null,
    'PLAYER_UPDATE_SUCCESS': null,
    'PLAYER_DELIVERED': null,
    'PLAYER_NOT_DELIVERED': null,
    'PLAYERS_LIST_FILTER': null,
    'PLAYERS_LIST_FILTER_SITE': null,
    'PLAYERS_LIST_FILTER_PLAYER_ID': null,
    'PLAYERS_LIST_FILTER_PLAYER_TYPE': null,
    'PLAYERS_LIST_FILTER_SERVICE_DEFAULT': null,
    'PLAYERS_LIST_FILTER_SERVICE_AUDIO': null,
    'PLAYERS_LIST_FILTER_SERVICE_VIDEO': null,
    'PLAYERS_LIST_FILTER_PRODUCT': null,
    'PLAYERS_LIST_FILTER_DEFAULT': null,
    'PLAYERS_LIST_FILTER_DEFAULT_DEFAULT': null,
    'PLAYERS_LIST_FILTER_DEFAULT_YES': null,
    'PLAYERS_LIST_FILTER_DEFAULT_NO': null,
    'PLAYERS_LIST_FILTER_SEARCH': null,
    'PLAYERS_LIST_FILTER_RESET': null,
    'COUNTRIES_LOAD_ERROR': null,
    'PLAYERS_LOAD_ERROR': null,
    'PLAYERS_LOAD_BAD_REQUEST_ERROR': null,
    'PLAYERS_LIST_FILTER_COUNTRY_DEFAULT': null,
    'PLAYERS_LIST_FILTER_COUNTRY': null,
    'PLAYERS_LIST_FILTER_UPDATED': null,
    'PLAYERS_LIST_FILTER_UPDATED_YES': null,
    'PLAYERS_LIST_FILTER_UPDATED_INCOMPLETE': null,
    'PLAYERS_LIST_FILTER_UPDATED_FAILED': null,
    'PLAYERS_LIST_FILTER_UPDATED_DEFAULT': null,
    'PLAYERS_LIST_FILTER_ONLINE': null,
    'PLAYERS_LIST_FILTER_ONLINE_YES': null,
    'PLAYERS_LIST_FILTER_ONLINE_NO': null,
    'PLAYERS_LIST_FILTER_ONLINE_DEFAULT': null,
    'PLAYERS_LIST_FILTER_EXTERNAL_ID': null,
    'PLAYERS_LIST_QUICK_SEARCH': null,
    'PRODUCTS_LOAD_ERROR': null,
    'PLAYERS_LIST_FILTER_PRODUCT_DEFAULT': null,
    'PLAYER_INFO_TITLE': null,
    'PLAYER_GENERAL': null,
    'PLAYER_LOCATION': null,
    'PLAYER_SHIPPING': null,
    'PLAYER_CONNECTIVITY': null,
    'PLAYER_MODEL': null,
    'PLAYER_DEVICE_ID': null,
    'PLAYER_TIMEZONE': null,
    'PLAYER_SITE_STATUS': null,
    'PLAYER_IP_ADDRESS': null,
    'PLAYER_FIRMWARE': null,
    'PLAYER_SERIAL_NUMBER': null,
    'PLAYER_DELIVERY_STATUS': null,
    'PLAYER_UPDATED': null,
    'PLAYER_MAC_ADDRESS': null,
    'PLAYER_LAST_UPDATE': null,
    'PLAYER_LAST_DOWNLOAD': null,
    'PLAYER_LAST_CONFIG': null,
    'PLAYER_LAST_TASK': null,
    'PLAYER_LAST_MONITORING': null,
    'PLAYER_LAST_PLAY': null,
    'PLAYER_PUBLIC_IP': null,
    'PLAYER_SITE_STATUS_STOP': null,
    'PLAYER_SITE_STATUS_TO_OFF': null,
    'PLAYER_SITE_STATUS_OFF': null,
    'PLAYER_SITE_STATUS_DEMO': null,
    'PLAYER_SITE_STATUS_EXPLOIT': null,
    'PLAYER_GENERAL_INFO': null,
    'PLAYER_MONITORING_INFO': null,
    'REFRESH_PLAYER': null,
    'GEOCODE_OVER_QUERY_LIMIT': null,
    'GEOCODE_GENERIC_ERROR': null,
    'GEOCODE_ZERO_RESULTS': null,
    'PLAYERS_DOWNLOAD_CSV_ERROR': null,
    'PLAYERS_DOWNLOAD_CSV_START': null,
    'PLAYER_INFO_ERROR': null,
    'PLAYER_SHIPPING_ERROR': null,
    'PLAYER_SHIPPING_TYPE': null,
    'PLAYER_SHIPPING_CARRIER': null,
    'PLAYER_SHIPPING_TRACKING': null,
    'PLAYER_SHIPPING_PICKUP_DATE': null,
    'PLAYER_SHIPPING_DELIVERY_DATE': null,
    'PLAYER_SHIPPING_DELIVERY_STATUS': null,
    'PLAYER_CONNECTIVITY_ERROR': null,
    'PLAYER_LIVE_CONNECTIVITY': null,
    'PLAYER_HISTORY_CONNECTIVITY': null,
    'PLAYER_CONNECTIVITY_LAST_UPDATE': null,
    'AUTH_LOGIN_PAGE_TITLE': null,
    'AUTH_LOST_PASSWORD_PAGE_TITLE': null,
    'AUTH_RESET_PASSWORD_PAGE_TITLE': null,
    'DASHBOARD_PAGE_TITLE': null,
    'ERROR_ACCESS_DENIED_PAGE_TITLE': null,
    'ERROR_NOT_FOUND_PAGE_TITLE': null,
    'PLAYERS_LIST_PAGE_TITLE': null,
    'PLAYERS_DETAILS_INFO_PAGE_TITLE': null,
    'PLAYERS_DETAILS_PLANNING_TITLE': null,
    'PLAYERS_DETAILS_PLAYLIST_TITLE': null,
    'PLAYERS_DETAILS_PLAY_LOGS_TITLE': null,
    'PLAYERS_DETAILS_EVENT_LOGS_TITLE': null,
    'PLAYERS_DETAILS_SCHEDULED_MESSAGES_TITLE': null,
    'USER_PAGE_TITLE': null,
    'USERS_LIST_PAGE_TITLE': null,
    'USERS_DETAILS_INFO_PAGE_TITLE': null,
    'USERS_DETAILS_SUBSCRIPTIONS_PAGE_TITLE': null,
    'USERS_DETAILS_AUTH0_PAGE_TITLE': null,
    'ANONYMOUS_USERNAME': null,
    'WARNING': null,
    'USER_SUBSCRIPTIONS_IMPORT_WARNING': null,
    'IMAGE_UPLOAD_INVALID_EXTENSION': null,
    'IMAGE_UPLOAD_PROCESSING_ERROR': null,
    'IMAGE_UPLOAD_GENERIC_ERROR': null,
    'PLAYER_AUDIO_UPDATE_SERVER': null,
    'PLAYER_AUDIO_PLANNING_TITLE': null,
    'PLAYER_AUDIO_PLAYLIST_TITLE': null,
    'PLAYER_PLAY_LOGS_TITLE': null,
    'PLAYER_EVENT_LOGS_TITLE': null,
    'PLAYER_AUDIO_SCHEDULED_MESSAGES_TITLE': null,
    'PLAYER_VIDEO_PLAYLIST_TITLE': null,
    'AUDIO_PROGRAMS_LOAD_ERROR': null,
    'AUDIO_PLANNINGS_LOAD_ERROR': null,
    'AUDIO_PLANNINGS_FILTER': null,
    'AUDIO_PLANNINGS_FILTER_PROGRAM': null,
    'AUDIO_PLANNINGS_FILTER_DAY': null,
    'AUDIO_PLANNINGS_FILTER_SEARCH': null,
    'AUDIO_PLANNINGS_FILTER_RESET': null,
    'AUDIO_PLANNINGS_START': null,
    'AUDIO_PLANNINGS_NAME': null,
    'AUDIO_PLANNINGS_DURATION': null,
    'AUDIO_PLANNINGS_TYPE': null,
    'AUDIO_PLANNINGS_PLAY': null,
    'MEDIA_AUDIO_MUSIC': null,
    'MEDIA_AUDIO_JINGLE': null,
    'MEDIA_AUDIO_SEQUENCE': null,
    'MEDIA_AUDIO_COMMERCIAL': null,
    'MEDIA_AUDIO_PAUSE': null,
    'PLAY_LOGS_FILTER': null,
    'PLAY_LOGS_FILTER_SEARCH': null,
    'PLAY_LOGS_FILTER_RESET': null,
    'PLAY_LOGS_FILTER_FILENAME': null,
    'PLAY_LOGS_FILTER_START_DATE': null,
    'PLAY_LOGS_FILTER_START_TIME': null,
    'PLAY_LOGS_FILTER_END_DATE': null,
    'PLAY_LOGS_FILTER_END_TIME': null,
    'PLAYER_PLAY_LOGS_START_TIME': null,
    'PLAYER_PLAY_LOGS_END_TIME': null,
    'PLAYER_PLAY_LOGS_FILENAME': null,
    'PLAYER_PLAY_LOGS_INFO': null,
    'PLAY_LOGS_LOAD_ERROR': null,
    'EVENT_LOGS_LOAD_ERROR': null,
    'EVENT_LOGS_FILTER': null,
    'EVENT_LOGS_FILTER_START_DATE': null,
    'EVENT_LOGS_FILTER_END_DATE': null,
    'EVENT_LOGS_FILTER_SEARCH': null,
    'EVENT_LOGS_FILTER_RESET': null,
    'EVENT_LOGS_TYPE': null,
    'EVENT_LOGS_NAME': null,
    'EVENT_LOGS_SOURCE': null,
    'EVENT_LOGS_TIME': null,
    'AUDIO_PLAYLISTS_LOAD_ERROR': null,
    'AUDIO_SCHEDULED_MESSAGES_LOAD_ERROR': null,
    'AUDIO_SCHEDULED_MESSAGES_FILTER': null,
    'AUDIO_SCHEDULED_MESSAGES_FILTER_DAY': null,
    'AUDIO_SCHEDULED_MESSAGES_FILTER_SEARCH': null,
    'AUDIO_SCHEDULED_MESSAGES_FILTER_RESET': null,
    'AUDIO_SCHEDULED_MESSAGES_ANNOUNCEMENT': null,
    'AUDIO_SCHEDULED_MESSAGES_CAMPAIGN': null,
    'AUDIO_SCHEDULED_MESSAGE_START_DATE': null,
    'AUDIO_SCHEDULED_MESSAGE_END_DATE': null,
    'AUDIO_SCHEDULED_MESSAGE_START_TIME': null,
    'AUDIO_SCHEDULED_MESSAGE_END_TIME': null,
    'AUDIO_SCHEDULED_MESSAGE_MONDAY': null,
    'AUDIO_SCHEDULED_MESSAGE_TUESDAY': null,
    'AUDIO_SCHEDULED_MESSAGE_WEDNESDAY': null,
    'AUDIO_SCHEDULED_MESSAGE_THURSDAY': null,
    'AUDIO_SCHEDULED_MESSAGE_FRIDAY': null,
    'AUDIO_SCHEDULED_MESSAGE_SATURDAY': null,
    'AUDIO_SCHEDULED_MESSAGE_SUNDAY': null,
    'AUDIO_SCHEDULED_MESSAGE_MEDIA_NAME': null,
    'AUDIO_SCHEDULED_MESSAGE_MEDIA_DURATION': null,
    'AUDIO_SCHEDULED_MESSAGE_MEDIA_PLAY': null,
    'AUDIO_PLAYER_NOT_SUPPORTED': null,
    'VIDEO_PLAYER_NOT_SUPPORTED': null,
    'VIDEO_PLAYLISTS_LOAD_ERROR': null,
    'VIDEO_PLAYLISTS_TYPE': null,
    'VIDEO_PLAYLISTS_THUMBNAIL': null,
    'VIDEO_PLAYLISTS_MEDIA_NAME': null,
    'VIDEO_PLAYLISTS_MEDIA_DURATION': null,
    'VIDEO_PLAYLISTS_SOURCE': null,
    'VIDEO_PLAYLISTS_PROGRAM_MODE': null,
    'VIDEO_PLAYLISTS_PROGRAM_NAME': null,
    'VIDEO_PLAYLISTS_MEDIA_RESOLUTION': null,
    'VIDEO_PLAYLISTS_MEDIA_ROTATION': null,
    'VIDEO_PLAYLISTS_PLAY': null,
    'VIDEO_PLAYER': null,
    'VIDEO_PLAYLISTS_FILTER': null,
    'VIDEO_PLAYLISTS_FILTER_DAY': null,
    'VIDEO_PLAYLISTS_FILTER_SEARCH': null,
    'VIDEO_PLAYLISTS_FILTER_RESET': null,
    'PLAYER_LOGS': null,
    'SOCIAL_LOGIN_INTRO': null,
    'LOGIN_TITLE': null,
    'AUDIO_PLAYLIST_ADN': null,
    'AUDIO_PLAYLIST_SHOW_ADN': null,
    'AUDIO_PLAYLIST_STATS_LOAD_ERROR': null,
    'AUDIO_PLAYLIST_ADN_TITLE': null,
    'AUDIO_PLAYLIST_ADN_PROGRAM': null,
    'AUDIO_PLAYLIST_ADN_DATE': null,
    'AUDIO_PLAYLIST_ADN_STYLES': null,
    'AUDIO_PLAYLIST_ADN_THEMES': null,
    'AUDIO_PLAYLIST_ADN_MOOD': null,
    'AUDIO_PLAYLIST_ADN_GENDERS': null,
    'AUDIO_PLAYLIST_ADN_LANGUAGES': null,
    'AUDIO_PLAYLIST_ADN_YEARS': null,
    'AUDIO_PLAYLIST_ADN_ENERGY': null,
    'AUDIO_PLAYLIST_ADN_TEMPO': null,
    'AUDIO_PLAYLIST_ADN_BPM': null,
    'DEFAULT_TITLE': null,
    'PLAYER_QUICK_SEARCH_PLACEHOLDER': null,
    'QUICK_SEARCH_BAD_REQUEST_ERROR': null,
    'QUICK_SEARCH_LOAD_ERROR': null,
    'QUICK_SEARCH_DIALOG': null,
    'QUICK_SEARCH_DIALOG_TITLE': null,
    'PLAYER_CLIENT': null,
    'GOTO_PLAYER': null,
    'LINK_EXTERNAL_IDENTITY': null,
    'ADMIN_ALERTS_LIST_TITLE': null,
    'ADMIN': null,
    'ADMIN_ALERTS': null,
    'QUICK_SEARCH_NO_RESULT': null,
    'ALERT_MESSAGES_LOAD_ERROR': null,
    'ALERT_MESSAGES_LIST_TITLE': null,
    'ALERT_MESSAGES_START': null,
    'ALERT_MESSAGES_END': null,
    'ALERT_MESSAGES_MESSAGE': null,
    'ALERT_MESSAGES_AUDIENCE': null,
    'ALERT_MESSAGES_ACTIONS': null,
    'ALERT_MESSAGES_AUDIENCE_ANY': null,
    'ALERT_MESSAGES_AUDIENCE_STOREVER': null,
    'ALERT_MESSAGES_AUDIENCE_NOTSTOREVER': null,
    'ALERT_MESSAGES_EDIT': null,
    'ALERT_MESSAGES_DELETE': null,
    'ALERT_MESSAGES_CREATE': null,
    'ALERT_MESSAGES_EDIT_DIALOG_TITLE': null,
    'ALERT_MESSAGES_CREATE_DIALOG_TITLE': null,
    'EDIT_ALERT_MESSAGE_FRENCH': null,
    'EDIT_ALERT_MESSAGE_DUTCH': null,
    'EDIT_ALERT_MESSAGE_ENGLISH': null,
    'EDIT_ALERT_MESSAGE_SAVE': null,
    'EDIT_ALERT_MESSAGE_START_DATE': null,
    'EDIT_ALERT_MESSAGE_END_DATE': null,
    'EDIT_ALERT_MESSAGE_PRODUCTS': null,
    'EDIT_ALERT_MESSAGE_AUDIENCE': null,
    'EDIT_ALERT_MESSAGE_FRENCH_REQUIRED': null,
    'EDIT_ALERT_MESSAGE_DUTCH_REQUIRED': null,
    'EDIT_ALERT_MESSAGE_ENGLISH_REQUIRED': null,
    'EDIT_ALERT_MESSAGE_FRENCH_MAX_LENGTH': null,
    'EDIT_ALERT_MESSAGE_DUTCH_MAX_LENGTH': null,
    'EDIT_ALERT_MESSAGE_ENGLISH_MAX_LENGTH': null,
    'EDIT_ALERT_MESSAGE_BROADCAST_REQUIRED': null,
    'EDIT_ALERT_MESSAGE_PRODUCTS_RESET': null,
    'CREATE_ALERT_MESSAGE_SUCCESS': null,
    'CREATE_ALERT_MESSAGE_VALIDATION_ERROR': null,
    'CREATE_ALERT_MESSAGE_ERROR': null,
    'UPDATE_ALERT_MESSAGE_SUCCESS': null,
    'UPDATE_ALERT_MESSAGE_VALIDATION_ERROR': null,
    'UPDATE_ALERT_MESSAGE_ERROR': null,
    'CONFIRM_DELETE_ALERT_MESSAGE_DIALOG': null,
    'CONFIRM_DELETE_ALERT_MESSAGE_DIALOG_TITLE': null,
    'CONFIRM_DELETE_ALERT_MESSAGE_DIALOG_ACCEPT': null,
    'CONFIRM_DELETE_ALERT_MESSAGE_MESSAGE': null,
    'DELETE_ALERT_MESSAGE_SUCCESS': null,
    'DELETE_ALERT_MESSAGE_ERROR': null,
    'CURRENT_ALERT_MESSAGES_ERROR': null,
    'ADMIN_ROLES_MANAGER_TITLE': null,
    'ADMIN_ROLES_MANAGER': null,
    'ROLES_MANAGER_TITLE': null,
    'ROLES_MANAGER_GROUP_ROLES': null,
    'ROLES_MANAGER_ADD_GROUP': null,
    'ROLES_MANAGER_REMOVE_GROUP': null,
    'ROLES_MANAGER_SELECT_GROUP': null,
    'GROUP_ROLE_EX_LOAD_ERROR': null,
    'ADMIN_GROUP_ROLE_NAME': null,
    'ADMIN_GROUP_ROLE_SAVE': null,
    'CREATE_GROUP_ROLES_DIALOG': null,
    'CREATE_GROUP_ROLES_TITLE': null,
    'CREATE_GROUP_ROLES_BUTTON': null,
    'GROUP_ROLES_NAME': null,
    'GROUP_ROLES_NAME_REQUIRED': null,
    'GROUP_ROLES_NAME_MIN_LENGTH': null,
    'GROUP_ROLES_NAME_MAX_LENGTH': null,
    'CONFIRM_DELETE_GROUP_ROLES_DIALOG': null,
    'CONFIRM_DELETE_GROUP_ROLES_DIALOG_TITLE': null,
    'CONFIRM_DELETE_EMPTY_GROUP_ROLES_MESSAGE': null,
    'CONFIRM_DELETE_GROUP_ROLES_DIALOG_ACCEPT': null,
    'CREATE_GROUP_ROLES_SUCCESS': null,
    'CREATE_GROUP_ROLES_VALIDATION_ERROR': null,
    'CREATE_GROUP_ROLES_ERROR': null,
    'UPDATE_GROUP_ROLES_SUCCESS': null,
    'UPDATE_GROUP_ROLES_VALIDATION_ERROR': null,
    'UPDATE_GROUP_ROLES_ERROR': null,
    'DELETE_GROUP_ROLES_SUCCESS': null,
    'DELETE_GROUP_ROLES_ERROR': null,
    'EXTERNAL_APPS': null,
    'ROLE_VIEW': null,
    'ROLE_PORTAL_ACTION': null,
    'ROLE_PORTAL_EVENTLOG': null,
    'ROLE_PORTAL_PLAYLOG': null,
    'ROLE_PORTAL_PLANNING': null,
    'ROLE_PORTAL_TICKET': null,
    'ROLE_RUNAS': null,
    'ROLE_PORTAL_USERMGR': null,
    'ROLE_PORTAL_STOREVER': null,
    'ROLE_PORTAL_EXPERT': null,
    'ROLE_PORTAL_PUBLISH': null,
    'ROLE_PORTAL_REBOOT': null,
    'ROLE_PORTAL_SRVLOG': null,
    'ROLE_DS_MEDIA': null,
    'ROLE_DS_UPLOAD': null,
    'ROLE_DS_EXPERT': null,
    'ROLE_CREATOR_UPLOAD_IMG': null,
    'ROLE_CREATOR_UPLOAD_SHAPE': null,
    'ROLE_CREATOR_TEMPLATE_NEW': null,
    'ROLE_CREATOR_TEMPLATE_SHARE': null,
    'ROLE_DS_SHARE': null,
    'ROLE_DS_ROTATE_MEDIA': null,
    'ROLE_CREATOR_EXPERT': null,
    'SITE_TITLE': null,
    'ROLE_DS_PUBLISH': null,
    'COMMANDS_LOAD_ERROR': null,
    'PLAYER_COMMANDS_TITLE': null,
    'PLAYER_COMMANDS_PAGE_TITLE': null,
    'COMMANDS_FILTER': null,
    'COMMANDS_FILTER_DAY': null,
    'COMMANDS_FILTER_SEARCH': null,
    'COMMANDS_FILTER_RESET': null,
    'COMMANDS_TEXT': null,
    'COMMANDS_USER': null,
    'CREATED': null,
    'COMMANDS_SEND_DATE': null,
    'COMMANDS_RESULT_DATE': null,
    'COMMAND_CUSTOM': null,
    'COMMAND_CTEST': null,
    'COMMAND_DIR': null,
    'COMMAND_CURCHAN': null,
    'COMMAND_KCHK': null,
    'COMMAND_CHKDSK': null,
    'COMMAND_ISP': null,
    'COMMAND_STASK': null,
    'COMMAND_DC': null,
    'COMMAND_PP_1': null,
    'COMMAND_PS_1': null,
    'COMMAND_POWER_ON': null,
    'COMMAND_POWER_OFF': null,
    'COMMAND_RANDOM_ON': null,
    'COMMAND_RANDOM_OFF': null,
    'COMMAND_STATUS': null,
    'COMMAND_TCP_FAST': null,
    'COMMAND_TCP_NORMAL': null,
    'COMMAND_TCP_ULTRAFAST': null,
    'COMMAND_RESTART': null,
    'COMMAND_SAF': null,
    'COMMAND_SDTEST': null,
    'COMMAND_SNUM': null,
    'COMMAND_CHANNEL': null,
    'COMMAND_SYSTAT': null,
    'COMMAND_TIME': null,
    'COMMAND_UCP': null,
    'COMMAND_UCA': null,
    'COMMAND_UP': null,
    'COMMAND_IDINBG_0': null,
    'COMMAND_IDINBG_1': null,
    'COMMAND_UD': null,
    'COMMAND_UO': null,
    'COMMAND_UF': null,
    'COMMAND_US': null,
    'COMMAND_VOLUME_MAX': null,
    'SEND_COMMAND_SUCCESS': null,
    'SEND_COMMAND_FAIL': null,
    'CUSTOM_COMMAND_DIALOG': null,
    'CUSTOM_COMMAND_DIALOG_TITLE': null,
    'SEND_COMMAND_BUTTON': null,
    'CUSTOM_COMMAND_LABEL': null,
    'CUSTOM_COMMAND_REQUIRED': null,
    'DASHBOARD_ADVANCED_COUNTERS_ERROR': null,
    'DASHBOARD_COUNTERS_ERROR': null,
    'RELOAD': null,
    'LOADING': null,
    'DASHBOARD_COUNTERS_TITLE_LOADING': null,
    'DASHBOARD_COUNTERS_TITLE_LOADED': null,
    'DASHBOARD_COUNTERS_PLAYER_TYPE_CHART': null,
    'DASHBOARD_COUNTERS_PLAYER_AUDIO_CHART': null,
    'DASHBOARD_COUNTERS_PLAYER_VIDEO_CHART': null,
    'DASHBOARD_COUNTERS_PLAYER_ONLINE_STATUS_CHART': null,
    'DASHBOARD_COUNTERS_PLAYER_ONLINE_CHART': null,
    'DASHBOARD_COUNTERS_PLAYER_OFFLINE_CHART': null,
    'DASHBOARD_COUNTERS_PLAYER_UPDATE_STATUS_CHART': null,
    'DASHBOARD_COUNTERS_PLAYER_UPDATED_CHART': null,
    'DASHBOARD_COUNTERS_PLAYER_NOT_UPDATED_CHART': null,
    'DASHBOARD_COUNTERS_PLAYER_UPDATE_INCOMPLETE_CHART': null,
    'DASHBOARD_COUNTERS_POINT_FORMAT_PART1': null,
    'DASHBOARD_COUNTERS_POINT_FORMAT_PART2': null,
    'PLAYER_CONNECTIVITY_STATS_ERROR': null,
    'DASHBOARD_CONNECTIVITY_STATS_ERROR': null,
    'DASHBOARD_CONNECTIVITY_TITLE': null,
    'DASHBOARD_CONNECTIVITY_CHART_TITLE': null,
    'DASHBOARD_CONNECTIVITY_CHART_SUBTITLE': null,
    'DASHBOARD_CONNECTIVITY_CHART_YAXIS': null,
    'DASHBOARD_SHIPPING_ERROR': null,
    'DASHBOARD_SHIPPING_INFO_TITLE': null,
    'DASHBOARD_SHIPPING_NAME': null,
    'DASHBOARD_SHIPPING_TYPE': null,
    'DASHBOARD_SHIPPING_CARRIER': null,
    'DASHBOARD_SHIPPING_TRACKING': null,
    'DASHBOARD_SHIPPING_PICKUP_DATE': null,
    'DASHBOARD_SHIPPING_DELIVERY_DATE': null,
    'DASHBOARD_SHIPPING_DELIVERY_STATUS': null,
    'DASHBOARD_SHIPPING_NO_DATA': null,
    'DASHBOARD_ACTIVITY_FEED_TITLE': null,
    'DASHBOARD_ACTIVITY_FEED_ERROR': null,
    'DASHBOARD_ACTIVITY_FEED_CREATE_GROUPROLE': null,
    'DASHBOARD_ACTIVITY_FEED_UPDATE_GROUPROLE': null,
    'DASHBOARD_ACTIVITY_FEED_DELETE_GROUPROLE': null,
    'DASHBOARD_ACTIVITY_FEED_CREATE_GROUPROLES': null,
    'DASHBOARD_ACTIVITY_FEED_UPDATE_GROUPROLES': null,
    'DASHBOARD_ACTIVITY_FEED_DELETE_GROUPROLES': null,
    'DASHBOARD_ACTIVITY_FEED_CREATE_USER': null,
    'DASHBOARD_ACTIVITY_FEED_UPDATE_USER': null,
    'DASHBOARD_ACTIVITY_FEED_DELETE_USER': null,
    'DASHBOARD_ACTIVITY_FEED_CREATE_USERS': null,
    'DASHBOARD_ACTIVITY_FEED_UPDATE_USERS': null,
    'DASHBOARD_ACTIVITY_FEED_DELETE_USERS': null,
    'DASHBOARD_ACTIVITY_FEED_NO_DATA': null,
    'DASHBOARD_LAST_SERVER_CALL_ERROR': null,
    'DASHBOARD_LAST_SERVER_CALL_TITLE': null,
    'DASHBOARD_LAST_SERVER_CALL_ONLINE': null,
    'DASHBOARD_LAST_SERVER_CALL_OFFLINE': null,
    'DASHBOARD_LAST_SERVER_CALL_NO_DATA': null,
    'DASHBOARD_LOGMATIC_ANALYZES_TITLE': null,
    'DASHBOARD_LOGMATIC_ANALYZES_ERROR': null,
    'DASHBOARD_LOGMATIC_ANALYZES_NO_DATA': null,
    'DASHBOARD_LOGMATIC_ANALYZES_ERROR_CODE': null,
    'DASHBOARD_LOGMATIC_ANALYZES_ERROR_NUMBER': null,
    'PLAYERS_LIST_FILTER_DELIVERY_STATUS': null,
    'PLAYERS_LIST_FILTER_DELIVERY_STATUS_DEFAULT': null,
    'PLAYERS_LIST_FILTER_DELIVERY_STATUS_DELIVERED': null,
    'PLAYERS_LIST_FILTER_DELIVERY_STATUS_IN_TRANSIT': null,
    'AUTH_LOGIN_TITLE': null,
    'ADMIN_CLIENTS_LIST_TITLE': null,
    'ADMIN_CLIENTS': null,
    'ADMIN_CLIENTS_LIST_FILTER': null,
    'ADMIN_CLIENTS_LIST_FILTER_SEARCH': null,
    'ADMIN_CLIENTS_LIST_FILTER_RESET': null,
    'ADMIN_CLIENTS_LIST_FILTER_NAME': null,
    'ADMIN_CLIENTS_LIST_FILTER_OFFICE': null,
    'ADMIN_CLIENTS_LIST_FILTER_SALES': null,
    'ADMIN_CLIENTS_LIST_FILTER_SERVICES': null,
    'ADMIN_CLIENTS_LIST_FILTER_SERVICES_DEFAULT': null,
    'ADMIN_CLIENTS_LIST_FILTER_SERVICES_AUDIO': null,
    'ADMIN_CLIENTS_LIST_FILTER_SERVICES_VIDEO': null,
    'ADMIN_CLIENTS_LIST_CREATE': null,
    'CLIENTS_LIST_LOAD_BAD_REQUEST_ERROR': null,
    'CLIENTS_LIST_LOAD_ERROR': null,
    'ADMIN_CLIENTS_NAME': null,
    'ADMIN_CLIENTS_OFFICE': null,
    'ADMIN_CLIENTS_SALES': null,
    'ADMIN_CLIENTS_SERVICES': null,
    'ADMIN_CLIENTS_UPDATED': null,
    'ADMIN_CLIENTS_CREATED': null,
    'SALES_LOAD_ERROR': null,
    'ADMIN_EDIT_CLIENT': null,
    'ADMIN_CREATE_CLIENT': null,
    'CLIENT_LOAD_ERROR': null,
    'EDIT_CLIENT_TITLE': null,
    'CREATE_CLIENT_TITLE': null,
    'SAVE_CLIENT_BUTTON': null,
    'CREATE_CLIENT_BUTTON': null,
    'CLIENT_NAME': null,
    'CLIENT_OFFICE': null,
    'CLIENT_SALES': null,
    'CLIENT_SERVICES': null,
    'CLIENT_SERVICE_AUDIO': null,
    'CLIENT_SERVICE_VIDEO': null,
    'CLIENT_APPLICATIONS': null,
    'CURRENT_CLIENT_LOAD_ERROR': null,
    'CLIENT_SALES_ME_BUTTON': null,
    'ADMIN_CLIENT_NOT_SALESMAN': null,
    'CLIENT_NAME_REQUIRED': null,
    'CLIENT_NAME_MAX_LENGTH': null,
    'CLIENT_OFFICE_REQUIRED': null,
    'CLIENT_SALES_REQUIRED': null,
    'CLIENT_APPS_LOAD_ERROR': null,
    'CREATE_CLIENT_VALIDATION_ERROR': null,
    'CREATE_CLIENT_ERROR': null,
    'CREATE_CLIENT_SUCCESS': null,
    'UPDATE_CLIENT_VALIDATION_ERROR': null,
    'UPDATE_CLIENT_ERROR': null,
    'UPDATE_CLIENT_SUCCESS': null,
    'AUTH_LOGIN_ERROR_TITLE': null,
    'AUTH_LOGIN_ERROR_PARA': null,
    'AUTH_LOGIN_GO_BACK_BUTTON': null,
    'USER_PROFILE_LOAD_ERROR': null,
    'USER_UNBLOCKED': null,
    'USER_BLOCKED': null,
    'AUTH_NEW_PASSWORD_PAGE_TITLE': null,
    'AUTH_NEW_PASSWORD_TITLE': null,
    'AUTH_NEW_PASSWORD_PARA': null,
    'AUTH_NEW_PASSWORD_ERROR': null,
    'AUTH_NEW_PASSWORD_SUCCESS': null,
    'AUTH_NEW_PASSWORD_NEW': null,
    'AUTH_NEW_PASSWORD_NEW_REQUIRED': null,
    'AUTH_NEW_PASSWORD_NEW_MINLENGTH': null,
    'AUTH_NEW_PASSWORD_CONFIRM': null,
    'AUTH_NEW_PASSWORD_CONFIRM_MISMATCH': null,
    'AUTH_NEW_PASSWORD_SUBMIT': null,
    'AUTH_NEW_PASSWORD_SUBMITTING': null,
    'PAGER_FIRST': null,
    'PAGER_PREVIOUS': null,
    'PAGER_NEXT': null,
    'PAGER_LAST': null,
    'USER_SUBSCRIPTIONS_FILTER': null,
    'EDIT_ALERT_MESSAGE_START_DATE_REQUIRED': null,
    'EDIT_ALERT_MESSAGE_START_DATE_INVALID': null,
    'EDIT_ALERT_MESSAGE_END_DATE_REQUIRED': null,
    'EDIT_ALERT_MESSAGE_END_DATE_INVALID': null,
    'EDIT_ALERT_MESSAGE_END_DATE_NOT_AFTER_START_DATE': null,
    'EDIT_ALERT_MESSAGE_START_DATE_TOO_EARLY': null,
    'COMMAND_LIST_FILTER_DAY_REQUIRED': null,
    'COMMAND_LIST_FILTER_DAY_INVALID': null,
    'DATE_TIME_PLACEHOLDER': null,
    'DATE_PLACEHOLDER': null,
    'AUDIO_SCHEDULED_MESSAGES_FILTER_DAY_REQUIRED': null,
    'AUDIO_SCHEDULED_MESSAGES_FILTER_DAY_INVALID': null,
    'VIDEO_PLAYLIST_FILTER_DAY_REQUIRED': null,
    'VIDEO_PLAYLIST_FILTER_DAY_INVALID': null,
    'VIDEO_PLAYLIST_FILTER_DAY_NOT_IN_RANGE': null,
    'AUDIO_PLANNING_FILTER_DAY_REQUIRED': null,
    'AUDIO_PLANNING_FILTER_DAY_INVALID': null,
    'AUDIO_PLANNING_FILTER_DAY_NOT_IN_RANGE': null,
    'EVENT_LOGS_FILTER_START_DATE_REQUIRED': null,
    'EVENT_LOGS_FILTER_START_DATE_INVALID': null,
    'EVENT_LOGS_FILTER_END_DATE_REQUIRED': null,
    'EVENT_LOGS_FILTER_END_DATE_INVALID': null,
    'EVENT_LOGS_FILTER_END_DATE_NOT_AFTER_START_DATE': null,
    'PLAY_LOGS_FILTER_START_DATE_REQUIRED': null,
    'PLAY_LOGS_FILTER_START_DATE_INVALID': null,
    'PLAY_LOGS_FILTER_END_DATE_REQUIRED': null,
    'PLAY_LOGS_FILTER_END_DATE_INVALID': null,
    'PLAY_LOGS_FILTER_END_DATE_NOT_AFTER_START_DATE': null,
    'DASHBOARD_ACTIVITY_FEED_CREATE_CLIENT': null,
    'DATATABLE_DEFAULT_EMPTY_TEXT': null,
    'CONFIRM_DELETE_NON_EMPTY_GROUP_ROLES_MESSAGE_ONE': null,
    'CONFIRM_DELETE_NON_EMPTY_GROUP_ROLES_MESSAGE_MANY': null,
    'ADMIN_CLIENTS_APPS': null,
    'ADMIN_CLIENT_APP_1': null,
    'ADMIN_CLIENT_APP_2': null,
    'ADMIN_CLIENT_APP_3': null,
    'ADMIN_CLIENT_APP_4': null,
    'DATETIME_PICKER_TODAY': null,
    'PLAY_LOGS_FILTER_EXCEEDED': 'Logs are maximum {{logs}} days time life',
    'DATETIME_PICKER_CLEAR': null,
    'DATETIME_PICKER_CLOSE': null,
    'DATETIME_PICKER_SELECT_MONTH': null,
    'DATETIME_PICKER_PREV_MONTH': null,
    'DATETIME_PICKER_NEXT_MONTH': null,
    'DATETIME_PICKER_SELECT_YEAR': null,
    'DATETIME_PICKER_PREV_YEAR': null,
    'DATETIME_PICKER_NEXT_YEAR': null,
    'DATETIME_PICKER_SELECT_DECADE': null,
    'DATETIME_PICKER_PREV_DECADE': null,
    'DATETIME_PICKER_NEXT_DECADE': null,
    'DATETIME_PICKER_PREV_CENTURY': null,
    'DATETIME_PICKER_NEXT_CENTURY': null,
    'DATETIME_PICKER_INCREMENT_HOUR': null,
    'DATETIME_PICKER_PICK_HOUR': null,
    'DATETIME_PICKER_DECREMENT_HOUR': null,
    'DATETIME_PICKER_INCREMENT_MINUTE': null,
    'DATETIME_PICKER_PICK_MINUTE': null,
    'DATETIME_PICKER_DECREMENT_MINUTE': null,
    'DATETIME_PICKER_INCREMENT_SECOND': null,
    'DATETIME_PICKER_PICK_SECOND': null,
    'DATETIME_PICKER_DECREMENT_SECOND': null,
    'CULTURE_COMMON': null,
    'CULTURE_OTHERS': null,
    'PLAYER_PLAY_LOGS_NAME': null,
    'PLAYER_CACHE': null,
    'ROLE_APS_MEDIA': null,
    'ROLE_APS_PUBLISH': null,
    'ROLE_APS_EXPERT': null,
    'CREATE_USER_NO_GROUPS': null,
    'EDIT_CLIENT_INFO': null,
    'WARNING_MESSAGE_PLANNING_UPDATE_FAIL': null,
    'WARNING_MESSAGE_PLAYLIST_UPDATE_FAIL': null,
    'WARNING_TITLE_UPDATE_FAIL': null,

    'GO_BACK': 'Terug',

    'PRIVACY_POLICY': 'Privacybeleid',
    'TERMS_OF_USE': 'Gebruiksvoorwaarden',

    'CLUF_TERMS_OF_USE': 'GEBRUIKSVOORWAARDEN',
    'CLUF_TERMS_OF_USE_TEXT':
      'Deze algemene voorwaarden bepalen de toegangs- en gebruiksvoorwaarden van de website van MCube en aanverwante sites (hierna de „Site“ genoemd) alsook de gebruiksvoorwaarden van de interactieve diensten (de „Diensten“ genoemd) die MCube u (hierna de „Gebruiker“ genoemd) via haar Site aanbiedt en handhaaft. De Diensten zijn slechts toegankelijk voor de klanten van MCube (hierna de „Klanten“ genoemd) voor de duur van de door hen met MCube afgesloten overeenkomst inzake geluidsinstallaties (audio- en/of -visuele) (hierna de „Overeenkomst“ genoemd). Het gaat onder meer om hostingdiensten, het verzenden van nieuwsbrieven, het verstrekken van op verzoek van de klant gecreëerde inhoud en hulpmiddelen voor het creëren van multimedia-inhoud en de programmering van berichten en audiovisuele campagnes (hierna de „Inhoud“ genoemd). De Diensten omvatten tevens het ter beschikking stellen van hulpmiddelen voor het beheer van de programma\'s (hierna de Programma\'s) van de Klant en de dienst na verkoop. Door gebruik te maken van de Diensten gaat u akkoord met deze Gebruiksvoorwaarden. Er kunnen aanvullende of bijzondere voorwaarden van toepassing zijn op bepaalde Diensten. Deze aanvullende voorwaarden worden u dan samen met de betreffende diensten ter beschikking gesteld.',

    'CLUF_USE_OF_OUR_SERVICES': 'Gebruik van onze Diensten',
    'CLUF_USE_OF_OUR_SERVICES_TEXT':
      'U stemt ermee in de regels na te leven die van toepassing zijn op de aan u ter beschikking gestelde Diensten en deze niet op oneigenlijke manier te gebruiken. In het bijzonder mag u onze Diensten niet verstoren of proberen toegang te krijgen tot onze Site of Diensten op een andere manier dan via de interface en met de instructies die wij u ter beschikking stellen. U mag onze Diensten alleen gebruiken in overeenstemming met de geldende regelgeving. We kunnen de toegang tot onze Site en de verstrekking van onze Diensten opschorten of beëindigen indien u zich niet houdt aan de voorwaarden of aan de toepasselijke regelgeving, of wanneer we redelijke gronden hebben om misbruik te vermoeden. U mag onze Site of Diensten, in hun geheel of gedeeltelijk, of de daarin opgenomen software niet kopiëren, wijzigen, distribueren, verkopen of verhuren. Evenmin mag u de broncode van dergelijke software decompileren of proberen te extraheren, behalve in gevallen waarin het recht tot decompileren is toegestaan door de wetgeving en voor zover toegestaan door dergelijke wetgeving, of indien u onze voorafgaande schriftelijke toestemming hebt verkregen. Het gebruik van onze Site en Diensten verleent u geen enkel recht van gebruik of intellectuele-eigendomsrechten op de Inhoud waar u toegang toe krijgt, of die u creëert op basis van onze Inhoud, tenzij anders bepaald in de Overeenkomst. De Inhoud omvat, in het bijzonder alle informatie, handelsmerken, al dan niet door intellectuele-eigendomsrechten beschermde creaties zoals foto\'s, muziek, teksten, video\'s, software, tabellen, beheersinstrumenten enz. Op onze Sites en Diensten kan Inhoud worden weergegeven die niet aan ons toebehoort en die door onze Klanten is verstrekt. Deze Inhoud is de exclusieve verantwoordelijkheid van de Klant of de entiteit die deze beschikbaar heeft gesteld. We kunnen de Inhoud controleren om ervoor te zorgen dat deze voldoet aan de toepasselijke regelgeving of aan onze Gebruiksvoorwaarden en deze verwijderen in geval van niet-naleving. In het bijzonder kunnen wij de accounts deactiveren van Gebruikers die een inbreuk hebben gepleegd op auteursrechten en naburige rechten. Het feit dat wij ons dit recht van controle en verwijdering voorbehouden, betekent echter niet noodzakelijk dat wij de Inhoud controleren.',

    'CLUF_PROTECTION_OF_PRIVACY': 'Bescherming van de privacy',
    'CLUF_PROTECTION_OF_PRIVACY_TEXT':
      'In het Privacybeleid van MCube wordt uitgelegd hoe we uw persoonsgegevens verwerken en hoe we uw privacy beschermen wanneer u onze Site en Diensten gebruikt. U accepteert uitdrukkelijk deze privacyregels voordat u onze Diensten gebruikt of u abonneert op onze nieuwsbrief.',

    'CLUF_CONTENT': 'Inhoud',
    'CLUF_CONTENT_TEXT':
      'Sommige van onze Diensten bieden u de mogelijkheid om inhoud te importeren, in te dienen, op te slaan, te verzenden of te ontvangen. U behoudt al uw intellectuele-eigendomsrechten in dergelijke inhoud. U garandeert MCube ook de wettigheid van de inhoud die u publiceert op de Site en de juistheid van de informatie, in het bijzonder de commerciële informatie over u. Wanneer u inhoud importeert, indient, opslaat, verstuurt naar of ontvangt via onze Diensten, verleent u MCube een wereldwijde licentie, voor de duur van uw Overeenkomst, om dergelijke inhoud te gebruiken, te hosten, op te slaan, te reproduceren, te wijzigen, er afgeleide werken van te maken (vertalingen, aanpassingen of andere wijzigingen om de werking van uw inhoud via onze Diensten te verbeteren), te communiceren, te publiceren, openbaar te maken, weer te geven of te verspreiden. Het gebruik van Inhoud die voor u is gemaakt en beschikbaar is gesteld door MCube is onderworpen aan de voorwaarden en beperkingen van de Overeenkomst die u bent aangegaan. MCube kan niet aansprakelijk worden gesteld voor enig gebruik buiten de voorwaarden van de Overeenkomst.',

    'CLUF_AMENDMENT_AND_TERMINATION': 'Wijziging en beëindiging van onze Diensten ',
    'CLUF_AMENDMENT_AND_TERMINATION_TEXT':
      'MCube wijzigt en verbetert regelmatig haar Diensten. MCube kan op elk moment functies toevoegen of verwijderen, maar ook de verstrekking van alle of een deel van de Diensten opschorten, stopzetten, of nieuwe beperkingen toevoegen of creëren voor het gebruik van de Diensten.',

    'CLUF_WARRANTIES_AND_DISCLAIMERS': 'Garanties en disclaimers',
    'CLUF_WARRANTIES_AND_DISCLAIMERS_TEXT':
      'De Site en de Diensten van MCube zijn onderworpen aan een inspanningsverbintenis. Ze zijn onderworpen aan een garantiebeperking voor zover toegestaan door de wet. MCube doet in het kader van deze Gebruiksvoorwaarden geen toezeggingen met betrekking tot de inhoud van de Site en Diensten, hun specifieke functies, betrouwbaarheid, beschikbaarheid of geschiktheid voor uw behoeften. MCube kan evenmin verantwoordelijk worden gehouden voor de eventuele incompatibiliteit van de hulpmiddelen en software die u gebruikt om toegang te krijgen tot onze Diensten. Voor zover toegestaan door de wet, is MCube niet aansprakelijk voor enige winstderving, verlies van inkomsten of gegevens, of enige indirecte, speciale, gevolg-, voorbeeldige of punitieve schade die u kunt lijden. In ieder geval zal de aansprakelijkheid van MCube met betrekking tot enige vordering op grond van deze Gebruiksvoorwaarden beperkt zijn tot redelijkerwijs voorzienbare verliezen of schade en tot de bedragen die worden betaald voor het gebruik van de Diensten.',

    'CLUF_ACCESS_RIGHTS': 'Toegangsrechten tot onze Diensten',
    'CLUF_ACCESS_RIGHTS_TEXT':
      'Wanneer u onze Diensten gebruikt namens een onderneming, handelt u in naam en voor rekening hiervan en moet u eerder de toelatingen hebben verkregen die vereist zijn volgens haar interne reglement om op te treden als beheerder en/of gebruiker van de interface en de Interactieve Diensten die u ter beschikking worden gesteld.',

    'CLUF_CHANGES_TO_THE_TERMS': 'Wijziging van de Gebruiksvoorwaarden',
    'CLUF_CHANGES_TO_THE_TERMS_TEXT':
      'Wijzigingen in de Gebruiksvoorwaarden hebben geen terugwerkende kracht en worden ten minste acht (8) dagen na publicatie van kracht. Wijzigingen die specifiek zijn voor een nieuwe functie van een Dienst of wijzigingen die om wettelijke redenen zijn aangebracht, worden echter onmiddellijk van kracht. Indien u de wijzigingen in de Gebruiksvoorwaarden niet accepteert, moet u het gebruik van onze Diensten staken.',

    'CLUF_APPLICABLE_LAW': 'Toepasselijk recht',
    'CLUF_APPLICABLE_LAW_TEXT':
      'In geval van tegenstrijdigheid tussen deze Gebruiksvoorwaarden en/of aanvullende voorwaarden en/of de Overeenkomst, prevaleren de Overeenkomst en vervolgens de aanvullende voorwaarden. Indien u deze Gebruiksvoorwaarden niet respecteert en wij niet onmiddellijk maatregelen treffen, betekent dit niet dat wij afstand doen van onze rechten. Indien blijkt dat een bepaalde clausule/voorwaarde niet van toepassing is, laat dit de overige bepalingen van deze Gebruiksvoorwaarden onverlet. Deze Gebruiksvoorwaarden zijn onderworpen aan het Belgisch recht en de Franstalige rechtbanken van Brussel, binnen de door de wet toegestane grenzen, in het bijzonder voor Gebruikers die geen ondernemingen zijn.',

    'SCOPE_OF_APPLICATION': 'Toepassingsgebieden',
    'SCOPE_OF_APPLICATION_TEXT':
      'Bij uw bezoek en gebruik van onze Site en onze Diensten zal MCube uw persoonsgegevens verzamelen, verwerken en, indien van toepassing, doorgeven in overeenstemming met de toepasselijke regelgeving (de Algemene verordening gegevensbescherming en de Belgische nationale wetgeving).De nieuwe technologieën zijn van essentieel belang voor onze activiteiten en de diensten die wij aanbieden, zoals de levering van inhoud, hulpmiddelen voor het creëren van multimedia-inhoud en de programmering van berichten en audiovisuele campagnes.Dit Privacybeleid beschrijft de maatregelen die zijn genomen om uw privacy te beschermen bij het gebruik van de Site en/of de Diensten en de rechten die u als Gebruiker en/of Klant in dit verband hebt.Het definieert de manier waarop uw persoonlijke toestemming wordt verkregen en de doeleinden van de verwerking.Door toegang te zoeken tot de Site en er verder door te bladeren en/of door gebruik te maken van de Diensten, verklaart u dat u dit Privacybeleid zorgvuldig hebt gelezen, er kennis van hebt genomen en het hebt aanvaard, zonder beperking of voorbehoud.Toekomstige aanpassingen kunnen niet worden uitgesloten; eventuele aanpassingen zullen op deze pagina worden gepubliceerd. Wij raden u daarom aan dit Privacybeleid regelmatig te lezen.',

    'CONTROLLER': 'De verwerkingsverantwoordelijke',
    'CONTROLLER_TEXT':
      'De verwerkingsverantwoordelijke is de bvba Storever Belgium, gevestigd te Internationalelaan 55, 1070 Anderlecht, België, opgenomen in het register der rechtspersonen onder bedrijfsnummer 0666834913; contactpersoon: support@mcubedigital.com;',

    'DATA_WE_COLLECT': 'Gegevens die we verzamelen',

    'STANDARD_DATA': 'Standaardgegevens',
    'STANDARD_DATA_TEXT':
      'Wanneer u de Site bezoekt of gebruik maakt van de Diensten, in het bijzonder wanneer u een account aanmaakt, worden de volgende persoonsgegevens verzameld:',

    'YOUR_IP_ADDRESS': 'uw IP-adres,',
    'THE_DNS_ADDRESS': 'het DNS-adres,',
    'THE_DATE_AND_DURATION': 'de datum en duur van uw bezoek aan de Site,',
    'THE_PAGES_YOU_VISIT': 'de pagina\'s die u bezoekt op de Site, ',
    'YOUR_BROWSER': 'uw browser, ',
    'URL_REFERRER': 'de verwijzer-URL.',

    'PERSONAL_CONTACT_DATA': 'Persoonlijke contactgegevens',
    'PERSONAL_CONTACT_DATA_TEXT':
      'Om de Diensten die op onze Site worden aangeboden te gebruiken, evenals voor de levering van Inhoud en Programma\'s, moet u een gebruikersaccount aanmaken (hierna de „Gebruikersaccount“ genoemd), waarvoor u de volgende persoonsgegevens moet verstrekken:',

    'YOUR_FIRST_AND_LAST_NAMES': 'uw voor- en achternaam, uw geslacht,',
    'YOUR_OCCUPATION': 'uw positie, indien van toepassing, binnen het klantbedrijf, ',
    'YOUR_EMAIL_ADDRESS': 'uw e-mailadres,',
    'YOUR_WORK_PHONE_NUMBER': 'uw zakelijk telefoonnummer (mobiel of vast), fax, skype (optioneel),',
    'YOUR_TIME_ZONE': 'uw tijdzone (ook optioneel).',

    'THESE_DATA_ARE_ALSO_COLLECTED':
      'Deze gegevens worden ook verzameld en verwerkt om u de Spelers te kunnen leveren en u de nodige bijstand te kunnen verlenen.We gebruiken deze informatie ook ter verificatie in het geval dat een derde uw e-mailadres gebruikt zonder uw toestemming.Bovendien worden de volgende gegevens bewaard voor de uitvoering van de overeenkomst:',

    'PHONE_CALLS': 'telefoongesprekken,',
    'MESSAGES_SENT_THROUGH': 'berichten verzonden via onze onlineberichtendienst.',

    'NO_SENSITIVE_DATA_SHALL_BE_COLLECTED': 'Er worden geen gevoelige gegevens verzameld.',

    'NEWSLETTER': 'Nieuwsbrief',
    'NEWSLETTER_TEXT':
      'Wij kunnen u marketing e-mails („Nieuwsbrieven“) sturen indien u ons hiervoor uw toestemming hebt gegeven. Onze Nieuwsbrieven bevatten informatie over onze bestaande en nieuwe diensten.U kunt zich afmelden voor het ontvangen van Nieuwsbrieven door te klikken op de link voor afmelding die zich onderaan al onze Nieuwsbrieven bevindt.Houd er wel rekening mee dat wanneer u ons verzoekt om te stoppen met het versturen van Nieuwsbrieven, we uw persoonsgegevens bewaren, evenals uw verzoek om ervoor te zorgen dat u van de verzendlijst van de Nieuwsbrieven wordt verwijderd.',

    'CONNECTION_TO_THE_SERVICE': 'Verbinding met de dienst en inhoud van derden',
    'CONNECTION_TO_THE_SERVICE_TEXT': 'Inhoud van derden, zoals Youtube-video\'s, Google Maps, RSS-databases of afbeeldingen van andere sites, kunnen in het online-aanbod worden opgenomen. Dit vereist ook dat de eigenaar van de inhoud (met verwijzing naar de derde eigenaar) het IP-adres van de gebruiker verzamelt. Dit is gerechtvaardigd omdat de inhoud zonder IP-adres niet naar de respectieve gebruikers kan worden verzonden. Bovendien is het IP-adres nodig om de inhoud weer te geven. We zorgen ervoor dat we geen inhoud gebruiken die door eigenaren direct via het IP-adres wordt verzonden. Bovendien hebben we geen invloed op de manier waarop de derde het IP-adres opslaat, bijvoorbeeld voor statistische analyse. Indien wij hiervan kennis hebben, zullen wij de klant hiervan op de hoogte stellen.',

    'COOKIES': 'Cookies',
    'COOKIES_TEXT':
      'Cookies zijn tekstbestanden waarmee wij informatie op uw computer kunnen opslaan. De informatie vervat in de cookies kan worden gebruikt om specifieke instellingen voor elk bezoek te bewaren, om bepaalde functies van de Site aan te bieden en om meer te weten te komen over hoe bezoekers onze Site gebruiken (gebruikersnaam, taal en andere weergave-instellingen). Deze informatie helpt ons onze Site te verbeteren en u de best mogelijke gebruikerservaring te bieden.Alle populaire webbrowsersoftware biedt opties om cookies van uw computer te blokkeren en te verwijderen. Houd er evenwel rekening mee dat het blokkeren of verwijderen van cookies uw gebruikerservaring kan verminderen of u kan beletten bepaalde functies van onze Site te gebruiken.Analytische cookies stellen ons in staat anonieme statistieken te verkrijgen over het bezoek aan onze Site om deze te optimaliseren en eventuele storingen op te sporen. Deze worden door Google Analytics op onze sites en applicaties geplaatst.Indien u niet wenst dat onze sites en diensten cookies in uw browser opslaan voor bezoekersstatistieken, kunt u op de volgende link klikken waar u aanvullende informatie vindt:Cookies Google Analyticshttps://tools.google.com/dlpage/gaoptoutWe gebruiken het Doubleclick-platform om de advertenties op onze websites te beheren. U kunt op de volgende link klikken om Doubleclick-cookies te beheren. https://www.google.com/settings/u/0/ads/authenticated',

    'PURPOSE_OF_YOUR_DATA_PROCESSING': 'Doel van de gegevensverwerking',
    'WE_ONLY_COLLECT_AND_PROCESS': 'Wij verzamelen en verwerken uw gegevens alleen voor de uitdrukkelijk vermelde doeleinden:',
    'YOUR_CONSENT_TO_RECEIVE_OUR_NEWSLETTERS': 'uw toestemming om onze nieuwsbrieven te ontvangen,',
    'THE_USE_OF_OUR_SITE_AND_SERVICES': 'het gebruik van onze Site en Diensten om uw programma\'s te beheren,',
    'the_implementation_of_the_service': 'de uitvoering van de dienstenovereenkomst tussen ons en uw onderneming. ',

    'HOW_LONG_YOUR_DATA_WILL_BE_STORED': 'Bewaartermijn van uw gegevens',
    'HOW_LONG_YOUR_DATA_WILL_BE_STORED_TEXT':
      'Wij bewaren uw gegevens alleen zolang als nodig is voor het leveren van de Diensten waarop u zich hebt geabonneerd. Daarnaast worden ze alleen bewaard voor statistische doeleinden, of in het kader van wettelijke verplichtingen, en zullen ze geen aanleiding geven tot exploitatie.',

    'TRANSFER_OF_YOUR_DATA': 'Doorgifte van uw gegevens',
    'TRANSFER_OF_YOUR_DATA_TEXT':
      'Wij slaan uw persoonsgegevens op in de Europese Unie. Het kan echter gebeuren dat ze worden doorgegeven aan onderaannemers of zakenpartners in andere landen. In het geval van een dergelijke doorgifte zorgen wij ervoor dat de verwerking wordt uitgevoerd in overeenstemming met dit privacybeleid en wordt beheerst door de modelcontractbepalingen van de Europese Commissie die een adequaat niveau van bescherming van de persoonlijke levenssfeer en de grondrechten van natuurlijke personen waarborgen.',
    'SECURITY': 'Beveiliging',
    'SECURITY_TEXT':
      'Wij hebben technische maatregelen getroffen, zoals versleuteling of wachtwoorden om uw gegevens en de systemen waarin ze zijn opgeslagen te beschermen. We nemen ook operationele maatregelen op het gebied van gegevensbescherming, zoals het beperken van het aantal mensen dat toegang heeft tot de databases. Wij zorgen ervoor dat deze beveiligingsmaatregelen regelmatig worden herzien en informeren ons over de veiligheidsnormen in de sector om op de hoogte te blijven van de beste praktijken.Voor onze onderaannemers en partners hanteren wij dezelfde veiligheidseisen. Wij zorgen ervoor dat zij zich er contractueel toe verbinden de technische en organisatorische maatregelen te nemen die nodig zijn voor de bescherming van de persoonsgegevens tegen toevallige of ongeoorloofde vernietiging, het toevallig verlies, de wijziging van of de toegang tot, en iedere andere niet toegelaten verwerking van de persoonsgegevens.',

    'RIGHTS_OF_ACCESS_AND_RECTIFICATION': 'Inzage- en rectificatierecht',
    'RIGHTS_OF_ACCESS_AND_RECTIFICATION_TEXT':
      'U kunt kopieën bekijken van de persoonsgegevens die wij bewaren en verzoeken om uw persoonsgegevens te wijzigen, te rectificeren of te wissen. U kunt ook de verwerking van uw gegevens beperken of er bezwaar tegen maken.U kunt inloggen op de Site om de gegevens op de Site bij te werken.Wanneer u ons uw toestemming hebt gegeven om uw gegevens bijvoorbeeld te gebruiken om u commerciële verzoeken te sturen, kunt u uw toestemming direct intrekken via de hyperlink die in zich in de tekst van de Nieuwsbrief bevindt. Dit heeft echter geen gevolgen voor de rechtmatigheid van gegevensverwerking uitgevoerd vóór het intrekken van uw toestemming.Om bezwaar te maken of gebruik te maken van uw rechten, kunt u contact met ons opnemen onder de voorwaarden die worden vermeld in het artikel „Klachten“ hieronder.Wanneer u contact met ons opneemt, zullen wij reageren zodra wij daartoe in staat zijn en indien nodig binnen twee maanden. Wanneer uw verzoek complex is, kan onze reactietermijn worden verlengd, maar wij zullen binnen nog eens maximaal twee maanden contact met u opnemen. De meeste verzoeken worden gratis behandeld, maar wij kunnen u vragen een redelijke administratieve vergoeding te betalen indien u ons bijvoorbeeld om een grote hoeveelheid gegevens vraagt. We kunnen u ook vragen uw identiteit te bewijzen voordat we u informatie kunnen verschaffen.',

    'CLAIMS': 'Klachten',
    'CLAIMS_TEXT':
      'Mocht u klachten hebben over de verwerking van uw persoonsgegevens door MCube, kunt u ons een e-mail sturen naar support@mcubedigital.com of ons een brief sturen op het volgende adres: Data Protection, bvba Storever Belgium, gevestigd te Internationalelaan 55, 1070 Anderlecht, België.Houd er rekening mee dat u het recht hebt een klacht in te dienen bij een toezichthoudende autoriteit voor gegevensbescherming in het land waar u woont of werkt of waar u van mening bent dat de wetten inzake gegevensbescherming zijn overtreden.Klanten in België kunnen de Gegevensbeschermingsautoriteit contacteren op het nummer +32 (0)2 274 48 00 of via het online contactformulier dat beschikbaar is op de website van de Autoriteit op www.gegevensbeschermingsautoriteit.be.',
    'Go_BACKOFFICE_MESSAGE': 'Gezien in backoffice',
    'DASHBOARD_UPDATE_TITLE': 'Statistieken Spelerupdate'
  }
